import { render, staticRenderFns } from "./AutomationImageTemplate.vue?vue&type=template&id=c422c2ac&"
import script from "./AutomationImageTemplate.vue?vue&type=script&lang=js&"
export * from "./AutomationImageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AutomationImageTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports